export const getFallbackName = (name: string): string => {
  // Handle non-string inputs and empty cases
  if (typeof name !== 'string' || !name || name.trim() === '') {
    return '';
  }

  const capitalizedName = name.trim().toUpperCase();

  // Single character case
  if (capitalizedName.length === 1) {
    return capitalizedName;
  }

  const nameArray = capitalizedName.split(' ').filter(Boolean);

  // Multiple words case - ensure second word exists
  if (nameArray.length > 1) {
    return `${nameArray[0][0]}${nameArray[1][0] || ''}`;
  }

  // Single word case
  return capitalizedName.slice(0, 2);
};

export const toTitleCase = (str: string): string => {
  // Handle non-string inputs and empty cases
  if (typeof str !== 'string' || !str || str.trim() === '') {
    return '';
  }

  // Split the string by spaces and handle each word
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => {
      // Skip empty words
      if (!word) return word;
      // Capitalize first letter and concatenate with rest of the word
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
